import PropTypes from "prop-types";
import Portal from "../../common/Portal";
import { useState, useEffect } from "react";
import { centerModal } from "../../../../services/modals";
import CloseButton from "../../common/CloseButton";
import styles from "./index.css";

const CenterDivModal = ({ children, onClosed }) => {
  const [modal, setModal] = useState(null);

  useEffect(() => {
    (async () => {
      const modal = await centerModal({
        onClosed: () => {
          setModal(null);
          onClosed();
        }
      });
      setModal(modal);
    })();
  }, []);

  if (!modal) {
    return null;
  }

  return (
    <Portal root={modal.div}>
      <>
        <CloseButton
          className={styles.closeButton}
          onClick={() => modal.close()}
        />
        {children}
      </>
    </Portal>
  );
};

CenterDivModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  onClosed: PropTypes.func
};

export default CenterDivModal;
